import { useEffect, useState } from "react";
// REDUX
import { useSelector } from "react-redux";
import { useGetLiftsQuery } from "../../redux/lifts/liftAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { LiftInterface } from "../../interfaces/Lift.interface";
import { RootState } from "../../app/store";

export default function useGetAllLifts() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [lifts, setLifts] = useState<LiftInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { globalOrganizationId } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetLiftsQuery(
		{ token, orgId: globalOrganizationId, page: 1, limit: 99999999 },
		{ skip: !token, refetchOnMountOrArgChange: false }
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setLifts(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		lifts,
		isLoadingGetAllLifts: isLoading || isFetching,
		errorMessageGetAllLifts: errorMessage,
		isErrorGetAllLifts: isError,
		totalRowsGetAllLifts: data?.total ?? 0,
	};
}
